$(document).ready(function () {
  // SmileAdvantage
  $(".coupons_discounts_text").html("$505");

//compariosn table heading
$(".compariosn_table_heading_text").html("EARLY BIRD BLACK FRIDAY SALE");
$(".compariosn_table_heading_text_offer").html("EARLY BIRD BLACK FRIDAY SALE");
$(".product_offer_title").html("Early Bird Black Friday Sale - Limited Time Offer");
$(".product_hot_tag").html('<img src="https://cdn.shopify.com/s/files/1/0710/7320/2496/files/Save_Hot_Tag.png?v=1793786154" alt="hot-tag" class="hot-tag">'); 
$(".product_hot_tag_upto").html('<img src="https://cdn.shopify.com/s/files/1/0710/7320/2496/files/Upto_Hot_Tag_2.png?v=1793786160" alt="hot-tag-upto" class="hot-tag">');

  
  $(".smileadvantage_price_text").html("$995 <del>$1,500</del> ");
  $(".smileadvantage__single_price_text").html("$995");
  $(".smileadvantage__single_del_price_text").html("$1,500");

  // SmileFlex Easy
  $(".smileflex_easy_price_text").html("$134");
  $(".smileflex_easy_downpayment").html("$399");
  $(".smileflex_easy_total").html("$1,199");
  $(".smileflex_easy_del").html("<del>$1,871</del>");
  $(".smileflex_easy_months").html("6 months");

  // NightAdvantage
   $(".nightadvantage_price_text").html("<del>$1,600</del> $1,095");
  $(".nightadvantage__single_price_text").html("$1,095");
  $(".nightadvantage__single_del_price_text").html("$1,600");

  // NightFlex Easy
  $(".nightflex_easy_price_text").html("$150");
  $(".nightflex_easy_downpayment").html("$499");
  $(".nightflex_easy_total").html("$1399");
   $(".nightflex_easy_del").html("<del>$1871</del>");
  $(".nightflex_easy_months").html("6 months");

  // Kit First Plan
  $(".kit_first_price_text").html("<del>$75</del> <strong>$32</strong>");
  $(".kit_first_price_text_regular").html("$32");

  // Sonic Electric Tootbrush
  $(".sonic_electric_toothbrush_price_text").html("$49.99");
  $(".sonic_electric_toothbrush_price_del_text").html("<del>$75</del>");

  // Aligner Cleaner + Whitener
  $(".aligner_cleaner_price_text").html("$31.49");
  // $(".aligner_cleaner_price_del_text").html("<del>$39.99</del>");

  // Teeth Whitening Pen
  $(".teeth_whitening_kit_price_text").html("$53.10");
  $(".retainers_price_text").html("$175.00");
  $(".teeth_whitening_pen_text").html("$17.99");
  $(".pull_tool_text").html("$19.99");
  $(".chewies_text").html("$19.99");
  $(".retainers_case_text").html("$19.99");
  // $(".retainers_case_price_del_text").html("<del>$25.00</del> ");
  $(".cheek_retractor_text").html("$19.99");
  $(".gift_card_text").html("$15");
  
  $(".night_guard_text").html("$190");
  $(".mouth_guard_text").html("$153");
  $(".soft_night_guard_del_price").html("$205");
  $(".soft_night_guard_price").html("$153");
  $(".hybrid_night_guard_price").html("$171");
  $(".hybrid_night_guard_del_price").html("$205");
  $(".hard_night_guard_price").html("$153");
  $(".hard_night_guard_del_text").html("$205");

   // Care Kit
  $(".care_kit_text").html("$48.60");

  // retainer
  
  $(".retainer_price_text").html("$175");
$(".retainers-del-price").html("<del>$210</del>");

  // teeth-whitening-kit
  $(".teeth_whitening_kit_price_text_regular").html("$34.99");
  $(".teeth_whitening_kit_price_text_wireless").html("$24.99");

  $(".teeth_whitening_kit_APR_text").html("$11.66/mo");
  $(".mouth-guards-price").html("$110");
  $(".mouth-guards-del-price").html("$205");
  $(".night-guards-del-price").html("$205");
  $(".night-guards-price").html("$110");
  // $(".ultrasonic-cleaner").html("$44.99");
  // $(".uv-ultrasonic-cleaner-price").html("$44.99");
  // $(".uv-ultrasonic-cleaner-price").html("$44.99");
  
  //retainer-set-pricing

  $(".retainer_1set_price_text").html("$175");
  $(".retainer_2set_price_text").html("$315");
  $(".retainer_2set_del_price_text").html("<del>$420</del>");
  $(".retainer_4set_price_text").html("$405");
    $(".retainer_4set_del_price_text").html("<del>$840</del>");
  $(".retainer_8set_price_text").html("$675");
    $(".retainer_8set_del_price_text").html("<del>$1680</del>");


  // Gift card
  $(".gift_card_1").html("$35");
  $(".gift_card_2").html("$60");
  $(".gift_card_3").html("$195");
  $(".gift_card_4").html("$590");
  $(".gift_card_5").html("$1,145");


  $(".friend_refer_text").html("$290");
  $(".consent-forms-text").html(`I expressly consent to receive marketing emails, texts, and calls (including autodialed/prerecorded calls, and including promotions, offers, and reminders such as abandoned cart follow-ups) from ALIGNERCO CORP. at the details I provided. I also acknowledge that calls and chat conversations with ALIGNERCO CORP. may be recorded, monitored, or saved for quality, training, and compliance purposes. Message & data rates may apply. Consent is not a condition of purchase. Withdraw anytime: unsubscribe, reply STOP, or visit our site. See <a href='https://alignerco.ca/pages/privacy-policy' target='_blank'>Privacy Policy</a>`);
});
